module.exports = __webpack_public_path__ + "static/cryptotwitter-d56dd25347cf6ccb6863cefc1b9f117f.jpg";